module.exports = __webpack_public_path__ + "media/images/icon-df6ffa31db97692b77a9619ca4ded57d.png";